import styled from 'styled-components';

export const MobileDepositBonusStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-image: url('/assets/bonus/bonus-deposit.gif');
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 290px;
    background-color: var(--color-surface);
    @media(max-height: 800px) {
      background-size: 260px;
    }
    @media(max-height: 500px) {
        h1 {
            font-size: 28px;
        }
        background-size: 230px;
    }
`;

export const MobileDepositBonusContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    text-align: center;
    margin: 0 auto;
    width: 100%;
    max-width: 400px;
    justify-content: center;
    height: 100%;
    flex-grow: 1;
    @media(max-height: 700px) {
      justify-content: end;
      padding-bottom: 100px;  
    }
    @media(max-height: 600px) {
      padding-bottom: 75px;
    }
    @media(max-height: 480px) {
      padding-bottom: 16px;
    }
`;

export const MobileDepositBonusTimeStyled = styled.div`
    border-radius: 2px;
    background: var(--color-base);
    font-size: 24px;
    display: flex;
    align-items: center;
    color: var(--color-yellow);
    font-weight: 700;
    padding: 4px 8px 4px 4px;
    margin: 24px 0 8px;
    svg {
        fill: var(--color-yellow);
        margin-right: 8px;
    }
    @media(max-height: 560px) {
      font-size: 14px;
      margin: 16px 0 0;
    }
`;

export const MobileDepositBonusContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
        font-size: 16px;
    }
  @media(max-height: 560px) {
    h1 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
  }
`;
